import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import DatePicker from 'react-datepicker';
import getLocale from '../../i18n/getLocale';

class AircraftBasesIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      today: '0000-00-00',
      date_start: null,
      aircraft_bases: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.refreshAircraftBases = this.refreshAircraftBases.bind(this);
    this.searchAircraftBases = this.searchAircraftBases.bind(this);
    this.loadData = this.loadData.bind(this);
    this.delete = this.delete.bind(this);
    this.changeActive = this.changeActive.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleChangeDatePicker (state, date) {
    var change = {};
    change[state] = date.format("DD/MM/YYYY");
    this.setState(change);
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  // Setamos o state.date para a data de hoje
  componentWillMount () {
      var today = new Date();
      var offset = -(today.getTimezoneOffset()/60);
      var today_str = new Date( new Date().getTime() + offset * 3600 * 1000).toJSON().slice(0,10).split('-').reverse().join('/');

      this.setState({date_start: today_str});
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');

    var datasave = {
      date_start: this.state.date_start,
    };

    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/frotas/disponiveis', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({aircraft_bases: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  searchAircraftBases(event) {
    var self = this;
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var datasave = {
      date_start: this.state.date_start,
    };

    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/frotas/disponiveis', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({aircraft_bases: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  refreshAircraftBases(event) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var datasave = {
      date_start: this.state.date_start,
    };

    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/frotas/disponiveis', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({aircraft_bases: responseJson.data});
        }
        self.handleAlert(event.message, event.status, 'open');
      }).then(() => {
      }); /* Overlay */
    });
  }

  delete (event) {
    var aircraft_base_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Frotas.StatusFrotas.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/frota/disponivel/' + aircraft_base_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshAircraftBases(responseJson);
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  changeActive (event) {
    var aircraft_base_staff_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Frotas.StatusFrotas.alertaFadiga);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/frota/disponivel/tripulante/' + aircraft_base_staff_id, { method: 'get', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshAircraftBases(responseJson);
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Frotas.StatusFrotas.titulo}</h3>
      <Link to="/adicionar/frota/disponivel" className="btn btn-warning pull-right"><i className="fa fa-pencil"></i> {this.locale.Frotas.StatusFrotas.botaoEditarStatus}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.searchAircraftBases}>
        <div className="row">
          <div className="col-md-3 col-md-offset-3">
            <div className="form-group">
              <DatePicker value={this.state.date_start} onChange={this.handleChangeDatePicker.bind(this, 'date_start')} className="form-control" />
            </div>
          </div>
          <div className="col-md-3">
            <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-search"></i> {this.locale.Frotas.StatusFrotas.botaoMudarData}</button>
          </div>
        </div>
      </form>
      <hr/>
      <h3 className="page-title">{this.locale.Frotas.StatusFrotas.tituloStatusParaData} {this.state.date_start}</h3>
      <hr/>
      {Object.keys(self.state.aircraft_bases).map(function(operation_type) {
        return (
          <div>
            <h4>{operation_type}</h4>
            <ul>
              {Object.keys(self.state.aircraft_bases[operation_type]).map(function(base) {
                return (
                  <div>
                    <h4>{base}</h4>
                    <ul>
                      {Object.keys(self.state.aircraft_bases[operation_type][base]).map(function(k) {
                        return (
                          <div>
                            <li>-
                              <strong> {self.state.aircraft_bases[operation_type][base][k].aircraft.registration} - {self.state.aircraft_bases[operation_type][base][k].aircraft.aircraft_model.consider_weight === 1 && <span>{this.locale.Frotas.StatusFrotas.listaFrotas.PMD} {self.state.aircraft_bases[operation_type][base][k].aircraft.weight_str} T - </span>} {self.state.aircraft_bases[operation_type][base][k].aircraft.aircraft_model.model}</strong> <button className="btn btn-sm btn-danger" value={self.state.aircraft_bases[operation_type][base][k].id} onClick={self.delete}><i className="fa fa-fw fa-trash"></i></button></li>
                            {(self.state.aircraft_bases[operation_type][base][k].availability == 1) ?
                              <li>- <strong>{this.locale.Frotas.StatusFrotas.listaFrotas.Disponivel}:</strong> <span className="label label-primary">{self.state.aircraft_bases[operation_type][base][k].availability_str}</span></li>
                              : <div>
                                  <li>- <strong>{this.locale.Frotas.StatusFrotas.listaFrotas.Disponivel}:</strong> <span className="label label-danger">{self.state.aircraft_bases[operation_type][base][k].availability_str}</span></li>
                                  <li>- <strong>{this.locale.Frotas.StatusFrotas.listaFrotas.Motivo}:</strong> <span className="label label-danger">{self.state.aircraft_bases[operation_type][base][k].reason}</span></li>
                                  <li>- <strong>{this.locale.Frotas.StatusFrotas.listaFrotas.Previsão}:</strong> <span className="label label-danger">{self.state.aircraft_bases[operation_type][base][k].available_date}</span></li>
                                  <li>- <strong>{this.locale.Frotas.StatusFrotas.listaFrotas.IndisponivelDesde}:</strong> <span className="label label-danger">{self.state.aircraft_bases[operation_type][base][k].indisp_date}</span></li>
                                </div>
                            }
                            <li>- <strong>{this.locale.Frotas.StatusFrotas.listaFrotas.AdicionadoPor}:</strong> {self.state.aircraft_bases[operation_type][base][k].user.name}</li>
                            <li>- <strong>{this.locale.Frotas.StatusFrotas.listaFrotas.InspetorMecanico}:</strong> {self.state.aircraft_bases[operation_type][base][k].mechanic}</li>
                            {(self.state.aircraft_bases[operation_type][base][k].flight_following_str == 'Normal') ?
                              <li>- <strong>{this.locale.Frotas.StatusFrotas.listaFrotas.FlightFollowing}:</strong> <span className="label label-primary">{self.state.aircraft_bases[operation_type][base][k].flight_following_str}</span></li>
                              : <li>- <strong>{this.locale.Frotas.StatusFrotas.listaFrotas.FlightFollowing}:</strong> <span className="label label-danger">{self.state.aircraft_bases[operation_type][base][k].flight_following_str}</span> - {self.state.aircraft_bases[operation_type][base][k].flight_following_reason} - desde: {self.state.aircraft_bases[operation_type][base][k].flight_following_date_str} </li>
                            }
                            {(self.state.aircraft_bases[operation_type][base][k].observations !== null) ?
                              <li>- <strong>{this.locale.Frotas.StatusFrotas.listaFrotas.Observacoes}:</strong> {self.state.aircraft_bases[operation_type][base][k].observations}</li>
                              : ""
                            }
                            <br/>
                            {((typeof self.state.aircraft_bases[operation_type][base][k].designation_1p_array !== "undefined") && (self.state.aircraft_bases[operation_type][base][k].designation_1p_array !== null)) ?
                              <li>-
                                <strong>{this.locale.Frotas.StatusFrotas.listaFrotas.Comandantes}:</strong>
                                {Object.keys(self.state.aircraft_bases[operation_type][base][k].designation_1p_array).map(function(kd) {
                                  return (
                                    <span>
                                      {self.state.aircraft_bases[operation_type][base][k].designation_1p_array[kd].name} <button className={(self.state.aircraft_bases[operation_type][base][k].designation_1p_array[kd].overnight === 1 ? "btn btn-sm btn-danger fa fa-calendar-times-o" : "btn btn-sm btn-success fa fa-calendar-check-o")} value={self.state.aircraft_bases[operation_type][base][k].designation_1p_array[kd].id} onClick={self.changeActive}></button>
                                    </span>
                                  );
                                })}
                              </li>
                              : ""
                            }
                            {((typeof self.state.aircraft_bases[operation_type][base][k].designation_2p_array !== "undefined") && (self.state.aircraft_bases[operation_type][base][k].designation_2p_array !== null)) ?
                              <li>-
                                <strong>{this.locale.Frotas.StatusFrotas.listaFrotas.Copilotos}:</strong>
                                {Object.keys(self.state.aircraft_bases[operation_type][base][k].designation_2p_array).map(function(kd) {
                                  return (
                                    <span>
                                      {self.state.aircraft_bases[operation_type][base][k].designation_2p_array[kd].name} <button className={(self.state.aircraft_bases[operation_type][base][k].designation_2p_array[kd].overnight === 1 ? "btn btn-sm btn-danger fa fa-calendar-times-o" : "btn btn-sm btn-success fa fa-calendar-check-o")} value={self.state.aircraft_bases[operation_type][base][k].designation_2p_array[kd].id} onClick={self.changeActive}></button>
                                    </span>
                                  );
                                })}
                              </li>
                              : ""
                            }
                            {((typeof self.state.aircraft_bases[operation_type][base][k].designation_3p_array !== "undefined") && (self.state.aircraft_bases[operation_type][base][k].designation_3p_array !== null)) ?
                              <li>-
                                <strong>{this.locale.Frotas.StatusFrotas.listaFrotas.Comissarios}:</strong>
                                {Object.keys(self.state.aircraft_bases[operation_type][base][k].designation_3p_array).map(function(kd) {
                                  return (
                                    <span>
                                      {self.state.aircraft_bases[operation_type][base][k].designation_3p_array[kd].name} <button className={(self.state.aircraft_bases[operation_type][base][k].designation_3p_array[kd].overnight === 1 ? "btn btn-sm btn-danger fa fa-calendar-times-o" : "btn btn-sm btn-success fa fa-calendar-check-o")} value={self.state.aircraft_bases[operation_type][base][k].designation_3p_array[kd].id} onClick={self.changeActive}></button>
                                    </span>
                                  );
                                })}
                              </li>
                              : ""
                            }
                            <hr/>
                          </div>
                        );
                      })}
                    </ul>
                    <hr/>
                  </div>
                );
              })}
            </ul>
            <hr/>
          </div>
        );
      })}
    </div>
  </div>
</div>
    );
  }
}

export default AircraftBasesIndex;



// WEBPACK FOOTER //
// ./src/Components/AircraftBases/AircraftBasesIndex.js